import { bindActionCreators } from 'redux';

const sockets = {};
const messageQueues = {};
const NORMAL_CLOSE_STATUS = 1000;

const noop = () => {};
const noopEventHandlers = {
  onopen: noop,
  onclose: noop,
  onerror: noop,
  onmessage: noop,
};

const doWebsocket = (socketURL, subscribeData, eventHandlers, store, action, options) => {
  const socket = sockets[action.type];
  let pullTimeout;

  // wipe the cached connection and create a new one
  if (socket) socket.close();

  const protocol = typeof options.protocol === 'function' ? options.protocol(store) : undefined;
  const ws = (sockets[action.type] = new window.WebSocket(socketURL, protocol));
  const boundEventHandlers = eventHandlers ? bindActionCreators(eventHandlers, store.dispatch) : { ...noopEventHandlers };
  const payload = subscribeData || action.payload;

  ws.onopen = (e) => {
    boundEventHandlers.onopen(e);

    if (payload) ws.send(payload);
    if (options.sendInterval) {
      pullTimeout = window.setInterval(() => ws.send(payload), options.sendInterval);
    }
  };

  ws.onclose = (e) => {
    console.warn(`Websocket connection closing for ${socketURL}`, e); // eslint-disable-line no-console

    if (pullTimeout) window.clearInterval(pullTimeout);
    boundEventHandlers.onclose(e);

    if (options.reconnect && e.code > NORMAL_CLOSE_STATUS) {
      window.setTimeout(() => doWebsocket(socketURL, subscribeData, eventHandlers, store, action, options), 2000);
    }
  };

  ws.onerror = boundEventHandlers.onerror;
  ws.onmessage = boundEventHandlers.onmessage;
};

const enqueueSend = (action) => {
  const { data, type } = action.payload;

  if (!Array.isArray(messageQueues[type])) messageQueues[type] = [];
  messageQueues[type].push(data);
};

if (typeof window !== 'undefined' && window.document && window.document.createElement) {
  // dequeue each message as ws object permits
  window.setInterval(() => {
    for (const key of Object.keys(messageQueues)) {
      const ws = sockets[key];
      if (!ws) continue;

      const datas = messageQueues[key];
      while (datas.length > 0) {
        if (ws.readyState !== 1) break;

        const message = datas.shift();
        ws.send(typeof message === 'object' ? JSON.stringify(message) : message);
      }
    }
  }, 100);
}

// heavily influenced by https://www.youfoundron.com/blog/websockets-in-redux-two-approaches/
const createSocketMiddleware = (
  socketURL,
  subscribeData,
  shouldInstantiate,
  shouldSend = () => {},
  eventHandlers,
  options = {} // sendInterval, reconnect
) => (store) => (next) => (action) => {
  if (shouldInstantiate(action)) doWebsocket(socketURL, subscribeData, eventHandlers, store, action, options);
  if (shouldSend(action)) enqueueSend(action);

  return next(action);
};

export default createSocketMiddleware;
